// Timeout in milliseconds for mouse hover delay after which the data is fetched.
export const PRE_FETCH_MOUSE_HOVER_DELAY = 250;

// Default garbage collection time in milliseconds for tanstack/react-query.
export const DEFAULT_GC_TIME = 1000 * 60 * 2; // 2min

export const BUDGET_TRUSTWORTHINESS_THRESHOLD = 0.3;
